import { render, staticRenderFns } from "./KakoDeluje.vue?vue&type=template&id=946fcda4&scoped=true"
var script = {}
import style0 from "./KakoDeluje.vue?vue&type=style&index=0&id=946fcda4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "946fcda4",
  null
  
)

export default component.exports